import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { useCountry } from '../../../components/CountrySelector';
import { Cart } from '../cart.rest';
import { useCart } from '../useCart';
import {
  UPDATE_CART_MUTATION,
  UpdateCartMutationAttributes,
  CartUpdateAction
} from './useUpdateCartMutation.rest';

export const useUpdateCartMutation = (overrideCart?: Cart) => {
  const countryCodeOriginal = useCountry().country.alpha2Code;
  const addressBasedApplePay = useFeatureFlag('address-based-apple-pay', [
    { default: false },
    { if: true, then: true }
  ]);
  const {
    cart: {
      attributes: { country2AlphaCode, countryCode }
    }
  } = useCart();
  const addressBasedCountryCode = country2AlphaCode || countryCode;
  const { cart: mojoCart } = useCart();

  const [mutate, { data, loading, error }] = useMutation(UPDATE_CART_MUTATION, {
    ...(overrideCart
      ? {
          fetchPolicy: 'no-cache'
        }
      : {})
  });

  const cart = overrideCart ? overrideCart : mojoCart;

  const updateCart = useCallback(
    async (
      actionType: CartUpdateAction,
      attributes: UpdateCartMutationAttributes,
      applePay = false
    ) => {
      const cartId = attributes.id || cart.id;

      if (!cartId) return Promise.reject('updateCartMutation: cart not found');

      return await mutate({
        variables: {
          id: cartId,
          countryCode:
            applePay && addressBasedApplePay ? addressBasedCountryCode : countryCodeOriginal,
          target: cart.attributes.version,
          input: {
            data: {
              action_type: actionType,
              attributes,
              id: cartId,
              type: 'carts'
            }
          }
        }
      });
    },
    [
      cart.id,
      cart.attributes.version,
      mutate,
      addressBasedApplePay,
      addressBasedCountryCode,
      countryCodeOriginal
    ]
  );

  return [updateCart, { data, loading, error }] as const;
};
